import isWithinInterval from 'date-fns/isWithinInterval'
import { LoggerUtils, DateUtils } from '@ocean/utils'
import { Person } from 'core/people/types'
import { SpecialUser } from 'modules/simulatorTrainings/common/types'
import { Workstation } from 'modules/simulatorTrainings/common/types/instructor'
import { WorkstationUtils } from 'modules/simulatorTrainings/common/utils'

type AssignAvailableWorkstationsBaseOptions = {
  workstations: Workstation[]
  assignedWorkstations: Record<string, string | undefined>
}

type AssignAvailableWorkstationsToInstructorsOptions = AssignAvailableWorkstationsBaseOptions & {
  instructors: Record<string, SpecialUser>
}

type AssignAvailableWorkstationsToStudentsOptions = AssignAvailableWorkstationsBaseOptions & {
  students: Record<string, Person>
}

class SchedulesUtils {
  isItCurrentSession(startDate: Date | string, endDate: Date | string) {
    const now = DateUtils.getDateNowGMT()
    const start = new Date(startDate)
    const end = new Date(endDate)

    try {
      return isWithinInterval(now, { start, end })
    } catch (error) {
      LoggerUtils.error('SchedulesUtils isItCurrentSession', error)
      return false
    }
  }

  assignAvailableWorkstationsToInstructors({
    workstations,
    assignedWorkstations,
    instructors,
  }: AssignAvailableWorkstationsToInstructorsOptions): Record<string, string> {
    let assignedInstructorWorkstations: Record<string, string> = {}
    const availableWorkstations = WorkstationUtils.getAvailableWorkstations(
      workstations,
      assignedWorkstations
    ) as string[]

    Object.keys(instructors).forEach((userId, index) => {
      assignedInstructorWorkstations[userId] = availableWorkstations[index]
    })

    return assignedInstructorWorkstations
  }

  assignAvailableWorkstationsToStudents({
    workstations,
    assignedWorkstations,
    students,
  }: AssignAvailableWorkstationsToStudentsOptions): Record<string, string> {
    let assignedStudentWorkstations: Record<string, string> = {}
    const availableWorkstations = WorkstationUtils.getAvailableWorkstations(
      workstations,
      assignedWorkstations
    ) as string[]

    Object.keys(students).forEach((userId, index) => {
      assignedStudentWorkstations[userId] = availableWorkstations[index]
    })

    return assignedStudentWorkstations
  }
}

export default new SchedulesUtils()
